import { useState, useEffect, useRef } from 'react'
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Close from 'mdi-material-ui/Close'
import Dialog from '@mui/material/Dialog'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ExpandIcon from 'mdi-material-ui/Fullscreen';
import SelectedIcon from 'mdi-material-ui/CheckboxMarkedOutline';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import TextField from '@mui/material/TextField';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import CheckedBox from 'mdi-material-ui/CheckboxOutline';
import UnCheckedBox from 'mdi-material-ui/CheckboxBlankOutline';
import MultimediaPreview from './MultimediaPreview';

import { type IPexelImageSearchResults, type IPexelsImage, PexelsService, IPexelVideoSearchResults, IPexelsVideo, IPexelsVideoFile } from "../services/PexelsService"

export interface PexelsSearchProps {
    onClose: () => void
    onAddImages: (images: File[], videoImage: string) => void
}

interface IPexelResource {
    id: string
    url: string
}

const PexelsSearch = (props: PexelsSearchProps) => {
    const [selectedTab, setSelectedTab] = useState("1");

    const [searchQuery, setSearchQuery] = useState("");

    const [pexelsImageSearchResults, setPexelsImageSearchResults] = useState<IPexelImageSearchResults>();

    const [pexelsVideoSearchResults, setPexelsVideoSearchResults] = useState<IPexelVideoSearchResults>();

    const [selectedImages, setSelectedImages] = useState<IPexelsImage[]>([]);

    const [selectedVideos, setSelectedVideos] = useState<IPexelsVideo[]>([]);

    const [inProgrss, setInProgrss] = useState(false);

    const [menuAnchorEl, setmenuAnchorEl] = useState<null | HTMLElement>(null);

    const [preview, setPreview] = useState<boolean>(false);

    const [MultimediaPreviewUrl, setMultimediaPreviewUrl] = useState<string>("");

    const [page, setPage] = useState(1);

    const [observerSwitch, setObserverSwitch] = useState<boolean>(false);

    const [isNewKeyword, setIsNewKeyword] = useState<boolean>(false);


    const openMenu = Boolean(menuAnchorEl);

    const handlePexelsSearch = async (e?: any) => {
        e && e.preventDefault();
        if (searchQuery) {
            setInProgrss(true);
            if (selectedTab == "1") {
                const pexelsServiceInstance = new PexelsService();
                const results = await pexelsServiceInstance.searchImages(searchQuery, page);
                setPexelsImageSearchResults((prevState) => {
                    if (!prevState || isNewKeyword) {
                        return results;
                    }

                    return {
                        ...prevState,
                        TotalResults: results.TotalResults,
                        Page: results.Page,
                        PerPage: results.PerPage,
                        NextPage: results.NextPage,
                        Photos: [...prevState.Photos, ...results.Photos],
                    };
                });
                setObserverSwitch((prevState) => !prevState);
            }
            else if (selectedTab == "2") {
                const pexelsServiceInstance = new PexelsService();
                const results = await pexelsServiceInstance.searchVideos(searchQuery, page);
                setPexelsVideoSearchResults((prevState) => {
                    if (!prevState || isNewKeyword) {
                        return results;
                    }

                    return {
                        ...prevState,
                        TotalResults: results.TotalResults,
                        Page: results.Page,
                        PerPage: results.PerPage,
                        NextPage: results.NextPage,
                        Videos: [...prevState.Videos, ...results.Videos],
                    };
                });
                setObserverSwitch((prevState) => !prevState);
            }
            if (isNewKeyword == true) setIsNewKeyword(false);
            setInProgrss(false);
        }
    }

    const endOfListRef = useRef(null);

    useEffect(() => {
        (async () => {
            await handlePexelsSearch();
            console.log("Current page:", page);
        })();
    }, [page]);

    useEffect(() => {

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setPage((prevPage) => prevPage + 1);
                }
            },
            {
                root: null,
                rootMargin: "0px",
                threshold: 0.1
            }
        );

        if (endOfListRef.current) {
            observer.observe(endOfListRef.current);
            console.log("Observing:", endOfListRef.current);
        }
        return () => {
            if (endOfListRef.current) observer.unobserve(endOfListRef.current);
        };
    }, [observerSwitch]);

    const handleImageSelection = async (item: IPexelsImage) => {
        setSelectedImages((prevState) => {
            return (prevState.includes(item)) ? prevState.filter(e => e.id !== item.id) : [...prevState, item];
        });
    }

    const handleVideoSelection = async (e: any, item: IPexelsVideo) => {
        setmenuAnchorEl(e.currentTarget);
        setSelectedVideos([item]);
    }

    const handleVideoQualitySelection = (file: IPexelsVideoFile) => {
        setmenuAnchorEl(null);
        selectedVideos[0].selectedFile = file;
    };

    const handleMenuClose = () => {
        setmenuAnchorEl(null);
    };

    const handleSelectedImagesFinalAddition = async (e: any) => {
        if (selectedImages.length > 0 || selectedVideos.length > 0) {
            setInProgrss(true);
            // Do synchronously
            /*for (let count = 0; count < selectedImages.length; count++) {
                selectedFiles.push(await urlToFile(selectedImages[count].original));
            }*/

            const images: IPexelResource[] = selectedImages.map((i: IPexelsImage) => ({ id: i.id, url: i.original }));
            const video: IPexelResource[] = selectedVideos.length > 0 && selectedVideos[0].selectedFile ? selectedVideos.map((i: IPexelsVideo) => ({
                id: i.id, url: i.selectedFile.link
            })) : [];

            const combined = [...images, ...video];

            // Do asynchronously
            const downloadedFiles = await urlToFiledownloadImages(combined);
            const validFiles = downloadedFiles.filter((file): file is File => file !== null);
            props.onAddImages(validFiles, selectedVideos[0]?.image);
            setInProgrss(false);
        }
        // else do nothing
    }

    async function urlToFiledownloadImages(urls: IPexelResource[]): Promise<(File | null)[]> {
        const downloadPromises = urls.map(async (url: IPexelResource) => {
            try {
                const response = await fetch(url.url);
                const blob = await response.blob();
                const file = new File([blob], url.url.split('/').pop() ?? '', { type: blob.type === '' ? 'video/mp4' : blob.type });

                console.log('Downloaded:', file);
                return file;
            } catch (error) {
                console.error('Error downloading image:', url, error);
                throw error;
            }
        });

        const downloadedFiles = await Promise.allSettled(downloadPromises);

        const failedDownloads = downloadedFiles.filter(result => result.status === 'rejected');
        if (failedDownloads.length > 0) {
            console.error('Some downloads failed:', failedDownloads);
        }

        let successfulDownloads = downloadedFiles.filter(result => result.status === 'fulfilled')
            .map(result => {
                if (result.status === 'fulfilled') {
                    return result.value;
                } else {
                    console.error('Error downloading image:', result.reason);
                    return null;
                }
            })
            .filter(result => result !== null);
        return successfulDownloads;
    }

    const handleExpansion = (item: any) => {
        setPreview(true);
        if (item.large) {
            setMultimediaPreviewUrl(item.large);
        } else if (item.url) {
            setMultimediaPreviewUrl(item.files[0].link);
        }
        console.log(item);
    }

    /*const urlToFile = async (url: string) => {
        const response = await axios.get(url, { responseType: 'blob' });
        const blob = response.data;
        const fileName = url.split('/').pop()?.split('?')[0] || 'default-filename';
        const file = new File([blob], fileName, { type: blob.type, lastModified: new Date().getTime() });
        return file;
    }*/

    return (
        
            <Dialog open={true} onClose={props.onClose} maxWidth={'sm'} fullWidth={true} >
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={inProgrss}
                    onClick={() => { setInProgrss(false) }}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <DialogTitle>Pexels Image Search</DialogTitle>
                <IconButton aria-label="close" sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8
                }}>
                    <Close onClick={() => { props.onClose(); }} />
                </IconButton>
                <DialogContent>
                    <form onSubmit={handlePexelsSearch}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Search from Pexels"
                            fullWidth
                            variant="standard"
                            onChange={(event) => {
                                setSearchQuery(event.target.value);
                                setIsNewKeyword(true);
                            }}
                        />
                        <Button type={"submit"} fullWidth sx={{ borderRadius: 0 }} variant="outlined" color="primary">Search</Button>
                    </form>
                    <Box sx={{ width: '100%' }}>
                        <TabContext value={selectedTab}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList variant="fullWidth"
                                    onChange={(event: any, newValue: string) => {
                                        setSelectedTab(newValue);
                                    }}
                                    centered>
                                    <Tab label="Images" value="1" />
                                    <Tab label="Videos" value="2" />
                                </TabList>
                            </Box>
                            <TabPanel sx={{ minHeight: "500px" }} value="1">
                                {
                                    pexelsImageSearchResults && pexelsImageSearchResults.Photos && pexelsImageSearchResults.Photos.length > 0 ?
                                        <ImageList sx={{ width: '100%' }} cols={3}>
                                            {
                                                pexelsImageSearchResults.Photos.map((item: IPexelsImage) => (
                                                    <ImageListItem key={item.id}>
                                                        <img
                                                            srcSet={`${item.tiny}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                                                            src={`${item.tiny}?w=164&h=164&fit=crop&auto=format`}
                                                            alt={item.alt}
                                                            loading="lazy"
                                                        />
                                                        <ImageListItemBar
                                                            sx={{
                                                                background:
                                                                    'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                                                                    'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                                                            }}
                                                            position="top"
                                                            actionIcon={
                                                                <>
                                                                    <Grid container gap={0.5}>
                                                                        <Grid item>
                                                                            <IconButton onClick={() => { handleExpansion(item) }}
                                                                                sx={{ color: 'white' }}>
                                                                                <ExpandIcon />
                                                                            </IconButton>
                                                                        </Grid>
                                                                        <Grid item>
                                                                            <IconButton onClick={(e) => { handleImageSelection(item) }}
                                                                                sx={{ color: selectedImages.includes(item) ? '#00e5ff' : 'white' }}>
                                                                                <SelectedIcon />
                                                                            </IconButton>
                                                                        </Grid>
                                                                    </Grid>
                                                                    {
                                                                        preview && (
                                                                            <MultimediaPreview onClose={() => { setPreview(false); }} url={MultimediaPreviewUrl} multiMediaType="image" />
                                                                        )}
                                                                </>
                                                            }
                                                        />
                                                    </ImageListItem>
                                                ))
                                            }
                                            <div style={{ marginTop: 20 }} ref={endOfListRef}>
                                            </div>

                                        </ImageList>
                                        :
                                        <Box border={1} display='flex' justifyContent='center'>Please search images to see results here</Box>
                                }
                            </TabPanel>
                            <TabPanel sx={{ minHeight: "500px" }} value="2">
                                {pexelsVideoSearchResults && pexelsVideoSearchResults.Videos && pexelsVideoSearchResults.Videos.length > 0 ?
                                    <ImageList sx={{ width: '100%' }} cols={3}>
                                        {
                                            pexelsVideoSearchResults.Videos.map((item: IPexelsVideo) => (
                                                <ImageListItem key={item.id}>
                                                    <video width="100%" height="100%" controls>
                                                        <source src={item.files[0].link} type={item.files[0].fileType} />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <ImageListItemBar
                                                        sx={{
                                                            background:
                                                                'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                                                                'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                                                        }}
                                                        position="top"
                                                        actionIcon={
                                                            <>
                                                                <Grid container gap={0.5}>
                                                                    <Grid item>
                                                                        <IconButton onClick={() => handleExpansion(item)}
                                                                            sx={{ color: 'white' }}>
                                                                            <ExpandIcon />
                                                                        </IconButton>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <IconButton onClick={(e) => { handleVideoSelection(e, item); }}
                                                                            sx={{ color: selectedVideos.includes(item) && item.selectedFile ? '#00e5ff' : 'white' }}	>
                                                                            <SelectedIcon />
                                                                        </IconButton>
                                                                    </Grid>
                                                                </Grid>
                                                                {
                                                                    preview && (
                                                                        <MultimediaPreview onClose={() => { setPreview(false); }} url={MultimediaPreviewUrl} multiMediaType="video" />
                                                                    )}
                                                            </>
                                                        }
                                                    />
                                                </ImageListItem>
                                            ))}
                                        <div style={{ marginTop: 20 }} ref={endOfListRef}>
                                        </div>

                                    </ImageList>
                                    :
                                    <Box border={1} display='flex' justifyContent='center'>Please search videos to see results here</Box>
                                }
                            </TabPanel>
                        </TabContext>
                    </Box>
                    <Menu anchorEl={menuAnchorEl} open={openMenu} onClose={handleMenuClose}>
                        {
                            selectedVideos && selectedVideos.length === 1 ? selectedVideos[0].files.map((f) =>
                                <>
                                    <MenuItem onClick={(e) => { handleVideoQualitySelection(f); }}>
                                        {
                                            selectedVideos[0].selectedFile == f ?
                                                <ListItemIcon>
                                                    <CheckedBox />
                                                </ListItemIcon>
                                                :
                                                <ListItemIcon>
                                                    <UnCheckedBox />
                                                </ListItemIcon>
                                        }
                                        {f.key}
                                    </MenuItem>
                                </>
                            ) : null
                        }
                    </Menu>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ borderRadius: 0, mt: 2 }} variant="outlined" color="secondary" autoFocus onClick={() => { props.onClose(); }}>
                        Close
                    </Button>
                    <Button onClick={(e) => {
                        handleSelectedImagesFinalAddition(e);
                    }} sx={{ borderRadius: 0, mt: 2 }} variant="outlined" color="primary">
                        Add Selected Images/Videos
                    </Button>
                </DialogActions>
                <Box sx={{ mb: 2 }}>
                    <Typography color="textSecondary" align="center">
                        Powered by <a href="https://www.pexels.com" target="_blank" style={{ color: '#00e5ff', textDecoration: 'none' }}>Pexels</a>
                    </Typography>
                </Box>
            </Dialog>
     
    )
}

export default PexelsSearch;
